import api from "../api";

export interface Payment {
  id: number;
  booking_id: number;
  status: string;
  amount: number;
  tip_amount: number;
  currency: string;
  payment_method?: 'card' | 'cash';
  payment_intent_id?: string;
  authorized_at?: string;
  captured_at?: string;
  refunded_at?: string;
  created_at: string;
  booking?: {
    id: number;
    service_type: string;
    from_address: string;
    to_address?: string;
    status: string;
    completed_at?: string;
  };
  driver?: {
    id: number;
    name: string;
  };
}

class PaymentService {
  async getPayments(params?: {
    booking_id?: number;
    status?: string;
  }): Promise<{ data: Payment[]; meta: any }> {
    const response = await api.get("/payments", { params });
    return response.data;
  }

  async authorizePayment(
    booking_id: number,
    payment_intent_id: string
  ): Promise<Payment> {
    const response = await api.post("/payments/authorize", {
      booking_id,
      payment_intent_id,
    });
    return response.data.data;
  }

  async payWithCash(booking_id: number): Promise<Payment> {
    const response = await api.post("/payments/cash", {
      booking_id,
    });
    return response.data.data;
  }

  async capturePayment(payment_id: number): Promise<Payment> {
    const response = await api.post("/payments/capture", {
      payment_id,
    });
    return response.data.data;
  }

  async addTip(payment_id: number, tip_amount: number): Promise<Payment> {
    const response = await api.post("/payments/tip", {
      payment_id,
      tip_amount,
    });
    return response.data.data;
  }

  async refundPayment(
    payment_id: number,
    amount?: number,
    reason?: string
  ): Promise<Payment> {
    const response = await api.post("/payments/refund", {
      payment_id,
      amount,
      reason,
    });
    return response.data.data;
  }
}

export default new PaymentService();
